import React, { useEffect, useState } from "react";
import "../../assest/css/Contactus.css";
import { Container, Row, Col, Form, Button, Card, Tabs, Tab, Alert } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaPhoneAlt,
} from "react-icons/fa";
import Footer from "../Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import Apiurl from "../environments/Apiurl";

const ContactUs = () => {
  const [meta, setMeta] = useState({});

  // Service Enquiry Form State
  const [formDataService, setFormDataService] = useState({
    firstName: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [submitMessageService, setSubmitMessageService] = useState("");
  const [submitErrorService, setSubmitErrorService] = useState("");
  const [isSubmittingService, setIsSubmittingService] = useState(false);

  // Course Enquiry Form State
  const [formDataCourse, setFormDataCourse] = useState({
    name: "",
    mobile: "",
    email: "",
    interestedCourse: "",
    preferredMode: "",
    courseCategory: "",
  });
  const [submitMessageCourse, setSubmitMessageCourse] = useState("");
  const [submitErrorCourse, setSubmitErrorCourse] = useState("");
  const [isSubmittingCourse, setIsSubmittingCourse] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      offset: 100,
      delay: 100,
    });

    const ContactusMeta = data[0]?.contactus_page;
    if (ContactusMeta) {
      setMeta(ContactusMeta);
    }
  }, []);

  const handleInputChangeService = (field, value) => {
    setFormDataService((prev) => ({ ...prev, [field]: value }));
  };

  const handleInputChangeCourse = (field, value) => {
    setFormDataCourse((prev) => ({ ...prev, [field]: value }));
  };

  const handleServiceSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingService(true);
    setSubmitMessageService("");
    setSubmitErrorService("");
    try {
      const submissionData = {
        name: formDataService.firstName,
        email: formDataService.email,
        phone_number: formDataService.phone,
        type_of_services: formDataService.service,
        message: formDataService.message,
      };

      const response = await axios.post(`${Apiurl}/project-enquiries`, submissionData);
      console.log("✅ Service form submitted successfully:", response.data);

      setSubmitMessageService("Thank you for your enquiry! We will contact you soon.");
      setFormDataService({
        firstName: "",
        email: "",
        phone: "",
        service: "",
        message: "",
      });
    } catch (error) {
      console.error("❌ Error submitting service form:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to submit enquiry. Please try again.";
      setSubmitErrorService(errorMessage);
    } finally {
      setIsSubmittingService(false);
    }
  };

  const handleCourseSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingCourse(true);
    setSubmitMessageCourse("");
    setSubmitErrorCourse("");
    try {
      const submissionData = {
        name: formDataCourse.name,
        email: formDataCourse.email,
        phone_number: formDataCourse.mobile,
        interested_course: formDataCourse.interestedCourse,
        preferred_mode: formDataCourse.preferredMode,
        course_category: formDataCourse.courseCategory,
      };

      const response = await axios.post(`${Apiurl}/course-enquiries`, submissionData);
      console.log("✅ Course form submitted successfully:", response.data);

      setSubmitMessageCourse("Thank you for your registration! We will contact you soon.");
      setFormDataCourse({
        name: "",
        mobile: "",
        email: "",
        interestedCourse: "",
        preferredMode: "",
        courseCategory: "",
      });
    } catch (error) {
      console.error("❌ Error submitting course form:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to submit registration. Please try again.";
      setSubmitErrorCourse(errorMessage);
    } finally {
      setIsSubmittingCourse(false);
    }
  };

  const services = [
    { id: 1, title: "Web Development" },
    { id: 2, title: "Mobile app Development" },
    { id: 3, title: "E-Commerce" },
    { id: 4, title: "ERP Software Development" },
    { id: 5, title: "CRM Service" },
  ];

  const courses = [
    { id: 1, title: "Full Stack Web Development" },
    { id: 2, title: "Python Programming" },
    { id: 3, title: "Data Science" },
    { id: 4, title: "Digital Marketing" },
    { id: 5, title: "Cyber Security" },
  ];

  const courseCategories = [
    { id: 1, label: "Student" },
    { id: 2, label: "Job Seeker" },
    { id: 3, label: "Working Professional" },
  ];

  return (
    <HelmetProvider>
      <div className="container-fluid p-0 one">
        <Helmet>
          <title>
            {meta?.title ||
              "Contact Us - Aalan TechSoft | Software Development & Training in Salem"}
          </title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Reach out to Aalan TechSoft, Salem's trusted software development company and training institute for all your tech needs."
            }
          />
        </Helmet>

        {/* Hero Section */}
        <div className="contactus-hero">
          <div className="about-content text-center">
            <div className="hero-title-container">
              <span className="badge-title">Contact Us</span>
              <br />
              <h1 className="text-white fw-bold">Let's Build Something Great Together.</h1>
            </div>
          </div>
        </div>
      </div>

      <Container className="py-5">
        <Row className="mb-5 py-5">
          {/* Left Form with Tabs */}
          <Col xs={12} lg={6} md={12} className="mx-auto">
            <Card className="contact-form-card custom-card-width shadow-lg rounded-4 p-3">
              <Card.Body>
                <Tabs defaultActiveKey="service" id="contact-tabs" className="mb-4">

                  {/* Service Enquiry Tab */}
                  <Tab eventKey="service" title="Service Enquiry">
                    <h3 className="contact-title mb-4" style={{ color: "#85bf39" }}>
                      Service Enquiry Form
                    </h3>
                    {submitMessageService && <Alert variant="success">{submitMessageService}</Alert>}
                    {submitErrorService && <Alert variant="danger">{submitErrorService}</Alert>}
                    <Form onSubmit={handleServiceSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Name *</Form.Label>
                        <Form.Control
                          type="text"
                          className="bg-white"
                          placeholder="Enter your name"
                          value={formDataService.firstName}
                          onChange={(e) => handleInputChangeService("firstName", e.target.value)}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Email *</Form.Label>
                        <Form.Control
                          type="email"
                          className="bg-white"
                          placeholder="Enter your email"
                          value={formDataService.email}
                          onChange={(e) => handleInputChangeService("email", e.target.value)}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Phone Number *</Form.Label>
                        <Form.Control
                          type="tel"
                          className="bg-white"
                          placeholder="Enter 10-digit phone number"
                          value={formDataService.phone}
                          onChange={(e) => handleInputChangeService("phone", e.target.value)}
                          pattern="[0-9]{10}"
                          maxLength={10}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Type of Services *</Form.Label>
                        <Form.Select
                          value={formDataService.service}
                          onChange={(e) => handleInputChangeService("service", e.target.value)}
                          required
                        >
                          <option value="">Select a Service</option>
                          {services.map((service) => (
                            <option key={service.id} value={service.title}>
                              {service.title}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Message *</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          className="bg-white"
                          placeholder="Enter your message"
                          value={formDataService.message}
                          onChange={(e) => handleInputChangeService("message", e.target.value)}
                          required
                        />
                      </Form.Group>

                      <div className="text-start">
                        <Button
                          type="submit"
                          className="btn btn-md sendmessage w-100"
                          disabled={isSubmittingService}
                        >
                          {isSubmittingService ? "Submitting..." : "Submit"}
                        </Button>
                      </div>
                    </Form>
                  </Tab>

                  {/* Course Enquiry Tab */}
                  <Tab eventKey="course" title="Course Enquiry">
                    <h3 className="contact-title mb-4" style={{ color: "#85bf39" }}>
                      Course Registration Form
                    </h3>
                    {submitMessageCourse && <Alert variant="success">{submitMessageCourse}</Alert>}
                    {submitErrorCourse && <Alert variant="danger">{submitErrorCourse}</Alert>}
                    <Form onSubmit={handleCourseSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Name *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter your name"
                          className="bg-white"
                          value={formDataCourse.name}
                          onChange={(e) => handleInputChangeCourse("name", e.target.value)}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Mobile *</Form.Label>
                        <Form.Control
                          type="tel"
                          placeholder="Enter 10-digit mobile number"
                          className="bg-white"
                          value={formDataCourse.mobile}
                          onChange={(e) => handleInputChangeCourse("mobile", e.target.value)}
                          pattern="[0-9]{10}"
                          maxLength={10}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Email ID *</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your email"
                          className="bg-white"
                          value={formDataCourse.email}
                          onChange={(e) => handleInputChangeCourse("email", e.target.value)}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Interested Course *</Form.Label>
                        <Form.Select
                          value={formDataCourse.interestedCourse}
                          onChange={(e) => handleInputChangeCourse("interestedCourse", e.target.value)}
                          required
                        >
                          <option value="">Select a course</option>
                          {courses.map((course) => (
                            <option key={course.id} value={course.title}>
                              {course.title}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Preferred Mode *</Form.Label>
                        <Form.Select
                          value={formDataCourse.preferredMode}
                          onChange={(e) => handleInputChangeCourse("preferredMode", e.target.value)}
                          required
                        >
                          <option value="">Choose a mode</option>
                          <option value="online">Online</option>
                          <option value="offline">Offline</option>
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="form-label">Course Category *</Form.Label>
                        <Form.Select
                          value={formDataCourse.courseCategory}
                          onChange={(e) => handleInputChangeCourse("courseCategory", e.target.value)}
                          required
                        >
                          <option value="">Select course category</option>
                          {courseCategories.map((cat) => (
                            <option key={cat.id} value={cat.label}>
                              {cat.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>

                      <Button
                        type="submit"
                        className="btn btn-md sendmessage w-100"
                        disabled={isSubmittingCourse}
                      >
                        {isSubmittingCourse ? "Submitting..." : "Register"}
                      </Button>
                    </Form>
                  </Tab>
                </Tabs>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Content */}
          <Col xs={12} md={12} lg={6} className="text-start d-flex flex-column mt-3 mt-md-5" data-aos="fade-down">
            <h2 className="section-title text-dark">
              Let's Build an awesome <span style={{ color: "#85bf39" }}>project together</span>
            </h2>
            <p className="section-text" style={{ textAlign: "justify" }}>
              Our IT company is dedicated to providing reliable support and solutions.
              Whether you need help with software, hardware, or network issues, we're
              here to keep your business running smoothly.
            </p>

            <Container className="pt-3">
              <Row className="gy-4">
                <Col md={6} data-aos="fade-up">
                  <div className="contact-box shadow-sm rounded-4 p-4 d-flex align-items-center">
                    <div className="contact-icon-box me-3">
                      <FaPhoneAlt className="contact-icon" />
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1">Call Us</h6>
                      <p className="mb-0">(+91) 9080108634</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} data-aos="fade-up" data-aos-delay="100">
                  <div className="contact-box shadow-sm rounded-4 p-4 d-flex align-items-center">
                    <div className="contact-icon-box me-3">
                      <FaEnvelope className="contact-icon" />
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1">Email Us</h6>
                      <p className="mb-0">support@aalantechsoft.com</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} data-aos="fade-up" data-aos-delay="100">
                  <div className="contact-box shadow-sm rounded-4 p-4 d-flex align-items-center">
                    <div className="contact-icon-box me-3">
                      <FaMapMarkerAlt className="contact-icon" />
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1">Visit Us</h6>
                      <p className="mb-0">J.H Towers, LIC Colony Rd, Salem-4.</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} data-aos="fade-up" data-aos-delay="100">
                  <div className="contact-box shadow-sm rounded-4 p-4 d-flex align-items-center">
                    <div className="contact-icon-box me-3">
                      <FaClock className="contact-icon" />
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1">Availability</h6>
                      <p className="mb-0">Mon - Sat, <br />9:00 AM - 7:00 PM</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        {/* Map */}
        <div className="map-container" data-aos="fade-up" data-aos-delay="100">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.9276725487387!2d78.1422186!3d11.6700898!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babf16817e1c0b1%3A0x5d809f79fa48173b!2sJH%20Tower%2C%20Hotel%20Vasantham%20Road%2C%20Salem%2C%20Tamil%20Nadu%20636004!5e0!3m2!1sen!2sin!4v1757915026829!5m2!1sen!2sin"
            width="100%"
            height="600"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Maps Location"
          />
        </div>
      </Container>
      <Footer />
    </HelmetProvider>
  );
};

export default ContactUs;